import React from "react";
import {
  GlobalStyle,
  PageWrapper,
  ContentCard,
  TopSection,
  LogoWrapper,
  Logo,
  InvitationBadge,
  Headline,
  HeadlineAccent,
  SubText,
  HeroSection,
  HeroInner,
  GlowBlob,
  ImageFrame,
  RingImage,
  SignUpButton,
} from "./styles/MuchBetterReferralDemoStyles";

import mbLogo from "./img/mb_logo.svg";
import ring from "./img/ring.png";

export default function MuchBetterReferralDemo() {
  return (
    <>
      <GlobalStyle />
      <PageWrapper>
        <ContentCard>
          {/* ── Top Content ── */}
          <TopSection>
            <LogoWrapper>
              <Logo src={mbLogo} alt="MuchBetter Logo" />
            </LogoWrapper>

            <InvitationBadge>Exclusive Invitation</InvitationBadge>

            <Headline>
              Join MuchBetter and <br />
              <HeadlineAccent>Get a Free Ring!</HeadlineAccent>
            </Headline>

            <SubText>
              Wow, you've seen MuchBetter in action! Sign up, load funds, and
              we'll send you a free MuchBetter Ring just for joining.
            </SubText>
          </TopSection>

          {/* ── Hero Image ── */}
          <HeroSection>
            <HeroInner>
              <GlowBlob />
              <ImageFrame>
                <RingImage src={ring} alt="MuchBetter Ring" />
              </ImageFrame>
            </HeroInner>
          </HeroSection>
        </ContentCard>
        <SignUpButton
          type="button"
          onClick={() =>
            window.open(
              `https://a.api.muchbetter.com/merchant/user?trackingCode=TXU2MjE=`,
              "_blank",
            )
          }
        >
          Sign Up Now
        </SignUpButton>
      </PageWrapper>
    </>
  );
}
